import React, { useEffect, useState } from 'react';

let pushToast = () => {};

export function showToast(msg) { pushToast(msg); }

export default function ToastHost() {
  const [msg, setMsg] = useState('');
  const [show, setShow] = useState(false);

  useEffect(() => {
    pushToast = (m) => {
      setMsg(m);
      setShow(true);
      setTimeout(() => setShow(false), 2800);
    };
  }, []);

  return <div className={`toast ${show ? 'show' : ''}`}>{msg}</div>;
}
